export default __webpack_public_path__ + "static/media/Magellanpinguin.711dbd75.jpg";